import { useTranslation } from 'next-i18next';

import { Button, Heading, HStack, Spinner, VStack } from '@chakra-ui/react';

import { IMAGE_SIZES, imageHelpers, ImageRatio, ImageSize } from '@nocowanie/core';
import { RoomImage } from '@nocowanie/common-ui';

import { ApartmentHeaderProps } from './apartment-header.props';

export const ApartmentHeader = ({
    name,
    isDrawerPending,
    imageSrc,
    showDetails,
    lineClamp = 2,
    ...props
}: ApartmentHeaderProps) => {
    const { t } = useTranslation('accommodation');

    return (
        <HStack align={'flex-start'} gap={4} {...props}>
            {imageSrc && (
                <RoomImage
                    flexShrink={0}
                    maxW={150}
                    ratio={ImageRatio['3/2']}
                    imageProps={{
                        src:
                            imageSrc &&
                            imageHelpers.wpresizer(
                                { ratio: ImageRatio['3/2'], size: ImageSize.Sm },
                                imageSrc,
                            ),
                        htmlWidth: IMAGE_SIZES[ImageRatio['3/2']][ImageSize.Sm].width,
                        htmlHeight: IMAGE_SIZES[ImageRatio['3/2']][ImageSize.Sm].height,
                        alt: name ?? '',
                    }}
                />
            )}
            <VStack align={'flex-start'}>
                <Heading as="h3" size={{ base: '2xs', md: 'xs' }} lineClamp={lineClamp}>
                    {name}
                </Heading>
                {showDetails && (
                    <Button
                        justifyContent="flex-start"
                        variant="link"
                        size={'sm'}
                        colorPalette="secondary"
                    >
                        {t('roomDetailsButton')}
                        {isDrawerPending ? <Spinner ml={2} size={'xs'} /> : null}
                    </Button>
                )}
            </VStack>
        </HStack>
    );
};
